module.exports = __webpack_public_path__ + "static/img/image014.1c992ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image014.png
// module id = ubXN
// module chunks = 1